import sliceCreator from '../../index.jsx';
import {UPDATE_VARIETY} from '../../../constants/index.jsx';
const _updateVarietyAction = sliceCreator('UPDATE_VARIETY', UPDATE_VARIETY, 'put');

const { asyncAction: updateVarietyAction, reducer, clearData: clearUpdateVarietyAction } = _updateVarietyAction;

export default reducer;

export {
    updateVarietyAction,
    clearUpdateVarietyAction
}